import { render } from "./Home.vue?vue&type=template&id=29ca902c"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script